module.exports = __webpack_public_path__ + "static/media/blog.e172319c.png";